import { useState, useEffect } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useTranslation } from "react-i18next";

import { InputWithCornerHint } from "@/shared/components/atoms/InputWithCornerHint";
import { SelectCountry } from "@/shared/components/organisms/SelectCountry";

import { useGetAllCountriesQuery } from "@/app/app.apiCountry";

export const FormCardPayment = ({
  handleChange,
  setFieldValue,
  values,
  errors,
  touched,
}) => {
  const { t } = useTranslation();
  const stripe = useStripe();
  const elements = useElements();
  console.log(errors);

  const [cardError, setCardError] = useState(""); // Mensaje de error de la tarjeta
  const [cardComplete, setCardComplete] = useState(false); // Estado de la tarjeta (completa o no)
  const [optionsCountryApi, setOptionsCountryApi] = useState([]); // Lista de países para el selector

  // Obtener países desde la API
  const {
    data: countries,
    isLoading: isLoadingCountries,
    isError: isErrorCountries,
  } = useGetAllCountriesQuery({});

  useEffect(() => {
    if (!isLoadingCountries && !isErrorCountries && countries?.length > 0) {
      const formattedCountries = countries.map((country) => ({
        id: country.name.common,
        name: country.name.common,
        code: country.cca2,
      }));
      setOptionsCountryApi(formattedCountries);
    }

    if (isErrorCountries) {
      console.error("Error al cargar los países.");
    }
  }, [countries, isLoadingCountries, isErrorCountries]);

  // Opciones de estilo para el CardElement
  const cardElementOptions = {
    style: {
      base: {
        color: "#32325d",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4",
        },
        ":-webkit-autofill": {
          color: "#32325d",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
        ":-webkit-autofill": {
          color: "#fa755a",
        },
      },
    },
  };

  // Manejar cambios en el CardElement
  const handleCardChange = (event) => {
    console.log(event);

    setCardError(event.error ? event.error.message : ""); // Actualiza el mensaje de error
    setCardComplete(event.complete); // Actualiza el estado de la tarjeta (completa o no)
  };

  return (
    <div className="mt-5">
      {/* Título */}
      <div className="mb-5">
        <h2 className="text-base font-semibold leading-7 text-gray-900">
          {t("fees.views.card_payment")}
        </h2>
      </div>

      {/* CardElement para ingresar los datos de la tarjeta */}
      <div className="ml-3">
        <div>
          <label
            htmlFor="card"
            className="block text-sm font-medium text-gray-700"
          >
            {t("store.views.card")}
          </label>
          <div className="mt-1">
            <CardElement
              id="card"
              options={cardElementOptions}
              onChange={handleCardChange}
              className="block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm border-2 py-2 px-1"
            />
          </div>
          {cardError && (
            <div className="text-red-600 text-sm mt-2">{cardError}</div>
          )}
          {cardComplete && !cardError && (
            <div className="text-green-600 text-sm mt-2">
              {t("fees.views.card_valid")}
            </div>
          )}
        </div>

        {/* Datos del propietario */}
        <div className="mt-8">
          <div className="mb-3">
            <h3 className="block text-base font-medium text-gray-700">
              {t("store.views.owner_data")}
            </h3>
          </div>

          <div className="space-y-3">
            <div className="col-span-full">
              <InputWithCornerHint
                label={t("branch.views.name")}
                span={t("general.mandatory")}
                name="name"
                error={!!errors.name}
                textError={errors.name}
                onChange={handleChange}
                value={values.name}
                type="text"
                placeholder={t("branch.views.name")}
              />
            </div>
            <div className="col-span-full">
              <InputWithCornerHint
                label={t("branch.views.email")}
                span={t("general.mandatory")}
                name="email"
                textError={errors.email}
                onChange={handleChange}
                value={values.email}
                type="email"
                placeholder={t("branch.views.email")}
              />
            </div>
            <div className="col-span-full">
              <InputWithCornerHint
                label={t("branch.views.adress")}
                span={t("general.mandatory")}
                name="address"
                error={!!errors.address}
                textError={errors.address}
                onChange={handleChange}
                value={values.address}
                type="text"
                placeholder={t("branch.views.adress")}
              />
            </div>
            <div className="col-span-full">
              {isLoadingCountries ? (
                <p className="text-gray-500 text-sm">{t("general.loading")}</p>
              ) : isErrorCountries ? (
                <p className="text-red-500 text-sm">
                  {t("general.error_loading_countries")}
                </p>
              ) : (
                <SelectCountry
                  span={t("general.mandatory")}
                  selected={optionsCountryApi.find(
                    (option) => option.id === values.country
                  )}
                  setSelected={(value) => {
                    setFieldValue("country", value.id);
                  }}
                  options={optionsCountryApi}
                  tittle={t("branch.views.country")}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
